import { render, staticRenderFns } from "./CallProblemsModal.vue?vue&type=template&id=aa8e0420&scoped=true&"
import script from "./CallProblemsModal.vue?vue&type=script&lang=js&"
export * from "./CallProblemsModal.vue?vue&type=script&lang=js&"
import style0 from "./CallProblemsModal.vue?vue&type=style&index=0&id=aa8e0420&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8e0420",
  null
  
)

export default component.exports